// See CheckBox.jsx: the input draws itself from the sprite, so there is no wrapper div and no
// hover state to track.
const RadioButton = ({ label, value, checked, onChange }) => {
  const handleChange = () => {
    onChange(value);
  };

  return (
    <span className="radio">
      <label>
        <input
          type="radio"
          value={value}
          className="radio_buttons optional icheck"
          checked={checked}
          onChange={handleChange}
        />
        {label}
      </label>
    </span>
  );
};

export default RadioButton;
